import { render, staticRenderFns } from "./SimpleSteps.vue?vue&type=template&id=6af5cdfe&"
import script from "./SimpleSteps.vue?vue&type=script&lang=js&"
export * from "./SimpleSteps.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSteps.vue?vue&type=style&index=0&id=6af5cdfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports